"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "registerWorker", {
    enumerable: true,
    get: function() {
        return registerWorker;
    }
});
const _worker_threads = require("worker_threads");
const _stdioStreamMarkers = require("./stdioStreamMarkers.js");
function registerWorker(fn) {
    _worker_threads.parentPort?.on("message", async (message)=>{
        let abortController;
        switch(message.type){
            case "start":
                abortController = new AbortController();
                return message.task && await start(message.id, message.task, abortController.signal);
            case "abort":
                return abortController?.abort();
            case "check-memory-usage":
                return reportMemory(_worker_threads.parentPort);
        }
    });
    async function start(workerTaskId, task, abortSignal) {
        try {
            process.stdout.write(`${(0, _stdioStreamMarkers.startMarker)(workerTaskId)}\n`);
            process.stderr.write(`${(0, _stdioStreamMarkers.startMarker)(workerTaskId)}\n`);
            const results = await fn(task, abortSignal);
            _worker_threads.parentPort?.postMessage({
                type: "status",
                err: undefined,
                results
            });
        } catch (err) {
            _worker_threads.parentPort?.postMessage({
                type: "status",
                err,
                results: undefined
            });
        } finally{
            process.stdout.write(`${(0, _stdioStreamMarkers.endMarker)(workerTaskId)}\n`);
            process.stderr.write(`${(0, _stdioStreamMarkers.endMarker)(workerTaskId)}\n`);
        }
    }
    function reportMemory(port) {
        const message = {
            type: "report-memory-usage",
            memoryUsage: process.memoryUsage().heapUsed
        };
        port.postMessage(message);
    }
}
